import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MaskedInput from './MaskedInput';

const StyledMaskedInput = styled(MaskedInput)`
  width: 100%;
`;

const FormikMaskedInput = ({ field, form, ...props }) => (
  <StyledMaskedInput {...field} {...props} />
);

FormikMaskedInput.propTypes = {
  field: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
};

export default FormikMaskedInput;
